module.exports = __webpack_public_path__ + "img/3.8de38d0a.jpg";